/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { IndexTable } from "../index_table";
import { Loader } from "../loader";
import camelize from "../../utils/camelize";
import { Tooltip, IconButton } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";
import { AbilityContext } from "../../contexts/abilityContext";

export const RestaurantTable = ({
  data,
  itemsPerPage,
  setItemsPerPage,
  page,
  setPage,
  pageCount,
  fetchingLoader,
  serverSort,
  onSortChange,
  serverOrderBy,
  serverOrder,
  showDownloadButton,
  disableDownloadButton,
  handleExportCsv,
  csvLoading,
  search,
  debouncedSearchTerm,
  }) => {
  const navigate = useNavigate();
  const { ability } = React.useContext(AbilityContext)

  const TableColumns = [
    { key: "id", sortable: true },
    { key: "name", sortable: true },
    { key: "phone", sortable: true },
    { key: "cuisine", sortable: true },
    { key: "created_at", sortable: true },
    { key: "sidekiq_jobs", sortable: true, minWidth: 100 },
    { key: "actions", sortable: false },
    { key: "app_visibility", sortable: true },
    { key: "profile_completion", sortable: true },
    { key: "translate", sortable: false },
  ];

  const columns = TableColumns?.map((column) => {
    return {
      key: column.key,
      label: camelize(column.key),
      sortable: column.sortable,
      minWidth: column.minWidth
    };
  });

  const getDate = (date) => {
    const surveyDate = new Date(date * 1000)
    return String(surveyDate).slice(0, 15)
  }

  const getPhoneNumberWithCountryCode = (data) => {
    let country_code = data?.phone_country_code || '+1'
    return country_code + data?.phone
  }

  const TableRows = (data) => {
    return data?.map((record) => {
      return {
        id: record?.id,
        name: record?.name,
        email: record?.email,
        phone: getPhoneNumberWithCountryCode(record),
        cuisine: record?.cuisine,
        created_at: moment.unix(record?.created_at).format("MM/DD/YYYY h:mm A"),
        actions: (
          <React.Fragment>
            <div style={{display: 'flex', gap: '2px'}}>
              <Tooltip title='Show' arrow>
                <IconButton onClick={() => navigate(`/admin/restaurant/update/${record?.id}`)}>
                  <VisibilityIcon
                    sx={{
                      color: '#707070',
                      cursor: 'pointer',
                    }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          </React.Fragment>
        )
      };
    });
  };

  const rows = TableRows(data);

  return (
    <React.Fragment>
      <div>
        {
          fetchingLoader && !search ? (
            <Loader />
          ) : (
            <IndexTable
              report={false}
              columns={columns}
              data={data}
              tableId="restaurants"
              type="entries"
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              page={page}
              setPage={setPage}
              pageCount={pageCount}
              sortMode={serverSort ? "server" : "client"}
              sortBy={serverOrderBy}
              sortOrder={serverOrder}
              onSortChange={onSortChange}
              showDownloadButton={showDownloadButton}
              disableDownloadButton={disableDownloadButton}
              handleExportCsv={handleExportCsv}
              csvLoading={csvLoading}
              searchLoading={fetchingLoader && !!debouncedSearchTerm}
              hasSearchTerm={!!debouncedSearchTerm}
            />
          )
        }
      </div>
    </React.Fragment>
  )
}
